import type { MenuDataItem } from '@ant-design/pro-components';
import dynamicRoutes from '../../config/dynamic-routes';

type RouteWithBadge = {
  path?: string;
  badge?: string;
  routes?: RouteWithBadge[];
};

function collectMenuBadges(routes: RouteWithBadge[], acc: Record<string, string>) {
  routes.forEach((route) => {
    if (route.path && route.badge) {
      acc[route.path] = route.badge;
    }
    if (route.routes?.length) {
      collectMenuBadges(route.routes, acc);
    }
  });
}

export const MENU_BADGE_BY_PATH: Record<string, string> = {};
collectMenuBadges(dynamicRoutes as RouteWithBadge[], MENU_BADGE_BY_PATH);

export function getMenuBadge(item: MenuDataItem): string | undefined {
  if (!item.path) {
    return undefined;
  }
  return MENU_BADGE_BY_PATH[item.path];
}
